import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TariffPricingConstraint from './tariff-pricing-constraint';
import TariffPricingConstraintDetail from './tariff-pricing-constraint-detail';
import TariffPricingConstraintUpdate from './tariff-pricing-constraint-update';
import TariffPricingConstraintDeleteDialog from './tariff-pricing-constraint-delete-dialog';

const TariffPricingConstraintRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TariffPricingConstraint />} />
    <Route path="new" element={<TariffPricingConstraintUpdate />} />
    <Route path=":id">
      <Route index element={<TariffPricingConstraintDetail />} />
      <Route path="edit" element={<TariffPricingConstraintUpdate />} />
      <Route path="delete" element={<TariffPricingConstraintDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TariffPricingConstraintRoutes;
